/** 与 AppFunctor `buildSegmentKey` / `normalizeSegmentText` 对齐（单段锚点匹配用） */

export function normalizeAiChatSegmentText(text: string): string {
  return String(text || '').replace(/\s+/g, ' ').trim();
}

export type AiChatSegmentAnchor = {
  threadId: string;
  segmentKey: string;
  texts: string[];
};

/** 某爆炸段是否命中任一对话锚点（按归一化文本） */
export function findChatAnchorForSegment(
  anchors: AiChatSegmentAnchor[] | undefined,
  segmentText: string,
): AiChatSegmentAnchor | null {
  const normalized = normalizeAiChatSegmentText(segmentText);
  if (!normalized || !anchors?.length) return null;
  return anchors.find((anchor) => anchor.texts.some((text) => text === normalized)) || null;
}
